export async function wait(ms: number): Promise<void> {
  return new Promise((r) => setTimeout(r, ms));
}

export class MinWait {
  private startDate: Date;

  private constructor(startDate: Date) {
    this.startDate = startDate;
  }

  public static begin(): MinWait {
    return new MinWait(new Date());
  }

  public async waitUntilPassed(waitTime: number): Promise<void> {
    if (waitTime <= 0) return;

    const passedTime = new Date().getTime() - this.startDate.getTime();
    if (passedTime >= waitTime) return;

    return wait(waitTime - passedTime);
  }

  public restart(): MinWait {
    this.startDate = new Date();
    return this;
  }
}
